import api from '../hooks/base-api'
import { Message, MessageBody } from '../models/interfaces';

const getChatList = (): Promise<any> => {
  return api.get('/v0/drives');
};

const getChatDetail = (id: string): Promise<any> => {
  return api.get(`/v0/drive/${id}/chat_contexts`);
};

const addNewChat = (data: any): Promise<any> => {
  return api.post('/v0/drives', data);
};

const deleteChat = (id: string): Promise<any> => {
  return api.delete(`/v0/drives`, { params: { id } });
};

const deleteSelectedChat = (ids: string[]): Promise<any> => {
  return api.delete(`/v0/drives`, { params: { ids: ids.reduce((f, s) => `${f},${s}`) } });
};

const updateTitle = (id: string, title: string): Promise<any> => {
  return api.put(`/v0/drives`, { title }, { params: { id } });
};

const deleteChatLogItem = (id: string): Promise<any> => {
  // return api.get(`/chat-log/${id}`)
  return Promise.resolve({
    code: 200,
    data: {
      id: id,
    },
  });
};

const chatMessage = (body: MessageBody): Promise<any> => {
  return api.post('/v0/chatgpt', body);
};

const createChatLog = (id: string, data: Message): Promise<any> => {
  return api.post(`/v0/drive/${id}/chat_contexts`, data);
};

export {
  getChatList,
  getChatDetail,
  addNewChat,
  deleteChat,
  updateTitle,
  deleteChatLogItem,
  chatMessage,
  createChatLog,
  deleteSelectedChat,
};
